module.exports = __webpack_public_path__ + "img/threshold.792a5cdc.svg";